module.exports = {"svg":{"$":{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 16 16"},"title":["UI_ErrorCircle2_16"],"path":[{"$":{"d":"M8,1A7,7,0,1,1,1,8,7,7,0,0,1,8,1M8,0a8,8,0,1,0,8,8A8,8,0,0,0,8,0Zm3.64,5.64L10.36,4.36,8,6.73,5.64,4.36,4.36,5.64,6.73,8,4.36,10.36l1.27,1.27L8,9.27l2.36,2.36,1.27-1.27L9.27,8Z","fill":"#464646"}}]}}


//////////////////
// WEBPACK FOOTER
// ./node_modules/xml-loader!./src/svg/UI_ErrorCircle2_16.svg
// module id = tz8s
// module chunks = 1